export default ({ estates }) => {
	return estates.reduce(
		(y, { block, ...estate }) =>
			Object.assign(y, {
				[block]: y[block] ? y[block].concat(estate) : [estate],
			}),
		{}
	);
};
